"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "chiaramonte-gulfi": {
    "bba35a2a": [{
      "hkey": "59a70191",
      "slug": "roccazzo-sperlinga",
      "name": "Roccazzo-Sperlinga",
      "primary": true,
      "skipSearch": false
    }],
    "roccazzo": [{
      "hkey": "59a70191",
      "slug": "roccazzo-sperlinga",
      "name": "Roccazzo-Sperlinga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;